"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ViewBadgeCertificate;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _TextButton = _interopRequireDefault(require("../../Button/TextButton"));

var s = {
  root: function root(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("color:", theme.color.dark.emerald, " !important;font-weight:500;font-stretch:normal;font-style:normal;letter-spacing:normal;line-height:1;", isMobile &&
      /*#__PURE__*/
      (0, _emotion.css)("font-size:12px;color:", theme.color.dark.topaz, " !important;"), ";")
    );
  }
};

var badgeCertificateClick = function badgeCertificateClick(e, props) {
  e.stopPropagation();
  e.preventDefault();
  var type = props.type;
  var handleClick = type === 'badge' ? props.onViewBadge : props.onViewCertificate;
  handleClick && handleClick(type);
};

function ViewBadgeCertificate(props) {
  var type = props.type,
      theme = props.theme,
      isMobile = props.isMobile,
      customClassName = props.customClassName;
  var text = type === 'badge' ? 'View Badge' : 'View Certificate';
  return _react.default.createElement(_TextButton.default, {
    className: (0, _classnames.default)(s.root(theme, isMobile), customClassName),
    onClick: function onClick(e) {
      return badgeCertificateClick(e, props);
    }
  }, text);
}